
define('text!templates/parts/filter/filter.html',[],function () { return '<div class="urowfix">\n    <div class="ucolfix filterby">{{#t}}calendar:Filter by{{/t}}</div>\n    <div class="ucolfix">\n        <div class="filter"></div>\n    </div>\n</div>\n';});

